export default __webpack_public_path__ + "static/media/1.f43b4a29.png";